import { useRouter } from '@tanstack/react-router'
import { AlertCircle } from 'lucide-react'

import { isModuleLoadError } from '@/lib/route-error'

import { BrandLogo } from './BrandLogo'
import { Button } from './Button'

export function RouteError({ error }: { error: unknown }) {
  const router = useRouter()
  const moduleError = isModuleLoadError(error)

  return (
    <main className="bg-canvas flex min-h-dvh items-center justify-center p-5">
      <div
        role="alert"
        className="border-line flex w-full max-w-md flex-col items-center gap-5 rounded-3xl border bg-white p-8 text-center"
      >
        <BrandLogo />
        <AlertCircle aria-hidden="true" className="text-brand-600 size-9" />
        <h1 className="text-xl font-bold">Halaman belum berhasil dimuat</h1>
        <p className="text-muted text-sm leading-relaxed">
          {moduleError
            ? 'Sebagian berkas aplikasi gagal dimuat. Muat ulang halaman untuk mengambil versi aplikasi terbaru.'
            : 'Terjadi kendala saat membuka halaman. Silakan coba lagi.'}
        </p>
        <Button
          onClick={() => {
            if (moduleError) window.location.reload()
            else void router.invalidate()
          }}
          className="rounded-lg"
        >
          {moduleError ? 'Muat ulang halaman' : 'Coba lagi'}
        </Button>
      </div>
    </main>
  )
}
